import { render } from "./DeviceMaster.vue?vue&type=template&id=4d8a2cc2&scoped=true"
import script from "./DeviceMaster.vue?vue&type=script&lang=js"
export * from "./DeviceMaster.vue?vue&type=script&lang=js"

import "./DeviceMaster.vue?vue&type=style&index=0&id=4d8a2cc2&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8a2cc2"]])

export default __exports__